"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedCategorySettingsToJSON = exports.FeaturedCategorySettingsFromJSONTyped = exports.FeaturedCategorySettingsFromJSON = exports.instanceOfFeaturedCategorySettings = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FeaturedCategorySettings interface.
 */
function instanceOfFeaturedCategorySettings(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFeaturedCategorySettings = instanceOfFeaturedCategorySettings;
function FeaturedCategorySettingsFromJSON(json) {
    return FeaturedCategorySettingsFromJSONTyped(json, false);
}
exports.FeaturedCategorySettingsFromJSON = FeaturedCategorySettingsFromJSON;
function FeaturedCategorySettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
    };
}
exports.FeaturedCategorySettingsFromJSONTyped = FeaturedCategorySettingsFromJSONTyped;
function FeaturedCategorySettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'enabled': value.enabled,
    };
}
exports.FeaturedCategorySettingsToJSON = FeaturedCategorySettingsToJSON;
